import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { canEdit } from '../utils/capabilities';
import AccessRestricted from '../pages/AccessRestricted';

type RequireEditorProps = {
  children?: React.ReactNode;
};

/**
 * Route-level guard for edit-oriented pages. Covers `editorOnly` nav items and
 * direct edit URLs so a viewer-only user who reaches them by a direct URL (deep
 * link) gets a clear read-only notice instead of an editor page that 403s.
 *
 * DEFAULT-OPEN: it keys off `canEdit` (= not positively-identified viewer-only),
 * so empty/unknown role sets — dev, dev-no-auth, tokens without realm roles —
 * keep full edit access and are never blocked.
 */
const RequireEditor: React.FC<RequireEditorProps> = ({ children }) => {
  const { user } = useAuth();

  if (!canEdit(user?.roles)) {
    return <AccessRestricted />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default RequireEditor;
